import { useRoutes } from 'react-router-dom';
import MainRoutes from './MainRoutes';
import AppRoutes from './AppRoutes';

export default function ThemeRoutes() {
  return useRoutes([MainRoutes, AppRoutes]);
}
